<template>
  <div
    :class="{
      'custom-input': true,
      'custom-input_error': signInError
    }"
  >
    <label class="custom-input__label" :for="inputId">{{ label }}</label>
    <input
      class="custom-input__item"
      :type="typeInput"
      @input="changeInput"
      :id="inputId"
      required
      :placeholder="placeholder"
    >
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'CustomInput',
  props: {
    typeInput: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: ''
    }
  },
  setup () {
    const store = useStore()

    const valueInput = ref(null) // получаю через ref в родителе

    const changeInput = (e) => {
      valueInput.value = e.target.value
    }

    const signInError = computed(() => store.getters.getSignInError)

    return {
      changeInput,
      valueInput,
      signInError
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 24px;

  &_error {
    border-color: #E31E24;
  }

  &__label {
    font-family: Roboto;
    font-weight: 500;
    font-size: 18px;

  }
  &__item {
    display:block;
    width: 100%;
    padding: 10px 12px;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    border-radius: 6px;
    box-sizing: border-box;
    border: 1px solid #000000;
    border-radius: 4px;

    &::-webkit-input-placeholder {
      color: #787878;
      font-size: 16px;
    }
  }
}

</style>
